export default function Logo({ light = false }) {
  const img = (
    <img
      src="/logo.png"
      alt="Casa Vale Engenharia e Construção Ltda."
      className={light ? "h-9 sm:h-10 w-auto" : "h-11 sm:h-[52px] w-auto"}
      data-testid="logo-image"
    />
  );
  if (light) {
    return (
      <span className="inline-flex items-center bg-white rounded-xl px-4 py-2.5" data-testid="logo">
        {img}
      </span>
    );
  }
  return (
    <span className="inline-flex items-center" data-testid="logo">
      {img}
    </span>
  );
}
